import React from 'react';
import { ArrowRight, CheckCircle } from 'lucide-react';

const CTA = ({ onEnrollClick }) => {
  const benefits = [
    "Lifetime access to all course materials",
    "HumanCodex framework certification",
    "Private community & weekly office hours",
    "Real-world projects & portfolio building",
    "30-day money-back guarantee"
  ];

  return (
    <section className="py-20">
      <div className="container">
        <div className="max-w-4xl mx-auto bg-card rounded-3xl p-12 shadow-lg border border-border text-center">
          <h2 className="heading-1 mb-4">
            Ready to Build AI That Actually Works?
          </h2>
          <p className="body-large text-secondary mb-8">
            Join the next cohort and master the HumanCodex NextXus Federation framework
          </p>

          <div className="flex flex-col items-center gap-6 mb-8">
            {benefits.map((benefit) => (
              <div key={benefit} className="flex items-center gap-3">
                <CheckCircle className="w-5 h-5 text-green-600" />
                <span className="body-medium">{benefit}</span>
              </div>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="btn-primary text-lg px-8 py-4" onClick={onEnrollClick}>
              Enroll Now - Limited Spots
              <ArrowRight className="w-5 h-5 ml-2" />
            </button>
          </div>

          <p className="caption text-muted mt-6">
            💳 Secure payment · 🔒 30-day money-back guarantee
          </p>
        </div>
      </div>
    </section>
  );
};

export default CTA;
